module.exports = __webpack_public_path__ + "2e5b67570d98b94c5bffb8784bc471ed.pdf";